module.exports = __webpack_public_path__ + "static/media/bug_fixed.eadd0216.png";